import BaseRequest from './request'
import {
	BASE_URL,
	TIME_OUT
} from '../config'
import LocalCache from '../catch/cache'
import {
	message
} from 'ant-design-vue';
import router from '../../router/index'

const service = new BaseRequest({
	baseURL: BASE_URL,
	timeout: TIME_OUT,
	interceptors: {
		requestInterceptor: (config) => {
			if (window.localStorage.getItem('token')) {
				const token = window.localStorage.getItem('token')
				if (token) {
					config.headers['token'] = `${token}`; 
				}
			}
			return config
		},
		requestInterceptorCatch: (error) => {
			return error
		},
		responseInterceptor: (res) => {
			if (res.data.code === -1) {
				message.error(res.data.msg)
				LocalCache.clearCache()
				router.push('/')
			}
			return res.data
		},
		responseInterceptorCatch: (error) => {
			return error
		}
	}
})

export default service
